export const labels = [
  "Jan",
  "Feb",
  "March",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const options: object = {
  responsive: true,
  maintainAspectRatio: false,
};

export const defaultData = {
  labels,
  datasets: [
    {
      label: "RD$",
      data: [],
      backgroundColor: "rgba(150, 199, 114, 0.35)",
      borderColor: "#96C772",
      pointBorderColor: "#fff",
      borderWidth: 2,
      pointRadius: 10,
      pointStyle: "circle",
      pointHoverRadius: 10,
      fill: true,
    },
  ],
};
